import { formatDate } from '@angular/common';

/**
 * convert Epoch To Date String
 * @param epoch
 * @returns
 */
export function convertEpochToDateString(epoch: number): string {
	try {
		const date = new Date(epoch);
		return formatDate(date, "dd MMM YYYY HH:mm:ss", "en-en")
	}
	catch (ex) {
		return ""
	}
}

/**
 * millisecondsToReadable
 * @param milliseconds 
 * @returns 
 */
export function millisecondsToReadable(milliseconds: number): string {
	if (milliseconds < 1000) {
		return `${milliseconds} ms`;
	}

	const seconds = Math.floor(milliseconds / 1000);
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	if (days > 0) {
		const remainingHours = hours % 24;
		return remainingHours > 0
			? `${days} day${days !== 1 ? 's' : ''} ${remainingHours} hour${remainingHours !== 1 ? 's' : ''}`
			: `${days} day${days !== 1 ? 's' : ''}`;
	}

	if (hours > 0) {
		const remainingMinutes = minutes % 60;
		return remainingMinutes > 0
			? `${hours} hour${hours !== 1 ? 's' : ''} ${remainingMinutes} minute${remainingMinutes !== 1 ? 's' : ''}`
			: `${hours} hour${hours !== 1 ? 's' : ''}`;
	}

	if (minutes > 0) {
		const remainingSeconds = seconds % 60;
		return remainingSeconds > 0
			? `${minutes} minute${minutes !== 1 ? 's' : ''} ${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`
			: `${minutes} minute${minutes !== 1 ? 's' : ''}`;
	}

	return `${seconds} second${seconds !== 1 ? 's' : ''}`;
}

/**
 * generateGUID
 * @returns
 */
export function generateGUID(): string {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	}).toUpperCase();
}

/**
* Checks if date is expired based on the days until the date
* @returns 
*/
export function isExpired(expiry: Date | string | number): boolean {

	if (expiry == 0) {
		return false;
	}

	const diffDays = getDaysUntilExpiry(expiry);
	if (diffDays < 0) {
		return true;
	}
	return false;
}

/**
* Calculates the number of days until the expiry date   
* @param expiry 
* @returns 
*/
export function getDaysUntilExpiry(expiry: Date | string | number): number {

	const expiryDate = new Date(expiry);
	const today = new Date();
	return Math.round((expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

}
